import { ViewPage } from '../scrutinizer/ViewPage';
import React, { useState, useEffect, useRef } from "react";
import { useReactToPrint } from 'react-to-print';
import { PROD, ROLES, MOBILE_NO_ERROR, INVALID_OTP_ERROR, LINKS } from '../../../common/constants';
import { Box, Button, CardContent, Card, Fab, Typography, Stack, Container, Grid, FormGroup, FormControlLabel, Checkbox, TextField } from '@mui/material';
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import jwt from 'jwt-decode';
import { useNavigate, useLocation } from "react-router-dom";
import { loaderService } from '../../../common/custom-loader/loader-service';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { ALLOCATE_WORKFLOW } from '../../../common/URLs';

import { toast } from 'react-toastify';
import { useGrowerIndividulalContextData } from './registrationDetails';
import { useGrowerMemberContextData } from './growerMember/registrationMemberDetails';
import { KeyboardArrowLeftRounded, Print as PrintIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { sendOTP, validateOTP } from '../../../common/Utils';
import { typeNumberValid } from '../../../common/commonValidations';
import { useTransporterContextData } from './transporter/registrationDetailsTransporter';
import { useHitContextData } from './hit/registrationDetailsHit';
import { useLleContextData } from './lle/registrationDetailsLle';
import { useTempStorageContextData } from './tempStorage/registrationDetailsTempStorage';
import { handleNumberFieldFocus } from '../../../common/commonFunction';
import { ApproveIcon, CloseIcon, ReportIcon, SubmitIcon } from '../../../common/icons';
import { useGrowerForestContextData } from './forest/registrationDetailsForest';
import apiClient from '../../../axios';

const Preview = (props) => {
  const { t } = useTranslation();
  const growerIndividulalContextData = useGrowerIndividulalContextData();
  const growerMemberContextData = useGrowerMemberContextData();
  const growerForestContextData = useGrowerForestContextData();
  const transporterContext = useTransporterContextData();
  const hitContext = useHitContextData();
  const lleContext = useLleContextData();
  const tempStorageContext = useTempStorageContextData();

  const getContext = () => {
    if (props?.stakeholderType === "Transporter") {
      return transporterContext;
    }
    else if (props?.stakeholderType === "HIT") {
      return hitContext;
    }
    else if (props?.stakeholderType === "LLE") {
      return lleContext;
    }
    else if (props?.stakeholderType === "TempStorage") {
      return tempStorageContext;
    }
    else if (props?.stakeholderType === "Grower") {
      if (props?.subCategory === "Individual") {
        return growerIndividulalContextData;
      }
      if (props?.subCategory === "Member") {
        return growerMemberContextData;
      }
      if (props?.subCategory === "Forest") {
        return growerForestContextData;
      }
    }
  }
  const { viewOnly, stakeHolderDetails, personalDetailsSectionOk, bankDetailsSectionOk, agreementDetailsSectionOk, financeDetailsSectionOk, qualificationDetailsSectionOk, locationDetailsSectionOk, chippingLocationDetailsSectionOk, jfmcDetailsSectionOk, vehicleDetailsSectionOk, landDetailsSectionOk, coupeDetailsSectionOk, beatDetailsSectionOk, showWorkFlowButtons, showClarificationButton, enableSaveSubmitButtons, setButtonAction, setCallUpdateApi, userType } = getContext();
  const componentRef = useRef(null);
  const print = useReactToPrint({
    content: () => componentRef.current,
  });
  const decoded = jwt(getLocalStorageItem('id_token'));
  const navigate = useNavigate();
  const [isStakeholder, setIsStakeholder] = useState(false);
  const loggedInUser = localStorage.getItem('uuid');
  const [workflowAction, setWorkflowAction] = useState();

  const [logModalOpenConfirm, setLogModalOpenConfirm] = useState(false);
  const handleLogModalConfirmOpen = () => setLogModalOpenConfirm(true);
  const handleLogModalConfirmClose = () => setLogModalOpenConfirm(false);

  const intitialError = {
    acceptTermError: ''
  };
  const [logModalYes, setLogModalYes] = useState(false);
  const handleLogModalYes = () => setLogModalYes(true);
  const handleConfirmLogModalClose = () => setLogModalYes(false);
  const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
  const [checkTermChecked, setCheckTermChecked] = useState(false);
  const [checkTermDisable, setCheckTermDisable] = useState(false);
  const [errorMessage, setErrorMessage] = useState(intitialError);
  const [otpValue, setOtpValue] = useState();
  const [otpHidden, setOtpHidden] = useState(true);
  const [verifyMobileNo, setVerifyMobileNo] = useState(false);

  const onSubmit = () => {
    handleLogModalConfirmClose();

    var workflowInitiatorID = (isStakeholder == true ? stakeHolderDetails?.id : loggedInUser);
    loaderService.showLoader();
    apiClient.post(ALLOCATE_WORKFLOW,
      {
        "stakeHolderMasterID": stakeHolderDetails?.id,
        "workflowInitiatorID": workflowInitiatorID,
        "workflowReceiverID": "",
        "workflowAction": workflowAction ? workflowAction : "Approve",
        "status": "",
        "isStakeHolderAction": isStakeholder,
        "workflowInitiatorRole": isStakeholder == true ? "" : localStorage.getItem('role'),
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          toast.success(response.data?.message);
          if (loggedInUser)
            navigate(-1);
          else
            navigate('/dashboardHome/dashboardStakeHolder');
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };
  const callBackMobileValidation = (response) => {
    setErrorMessage({ ...errorMessage, mobileNoError: "" });
    if (response.isSuccess) {
      setErrorMessage({ ...errorMessage, OTPSentError: "", mobileNoError: "", acceptTermError: "", acceptTermError: "" })
      setVerifyMobileNo(true);
      setOtpHidden(false);
      setCheckTermChecked(true);
      setCheckTermDisable(true);
    }

  }
  const callBackOTPValidation = (response) => {
    setErrorMessage({ ...errorMessage, OTPSentError: "" });
    setErrorMessage({ ...errorMessage, mobileNoError: "" });
    if (response.isSuccess === true) {
      setVerifyMobileNo(false);
      setOtpHidden(true);
      setMobileOTPValidated(true);
      setErrorMessage({ ...errorMessage, OTPError: "", mobileNoError: "", acceptTermError: "" });
    }
    else {
      setErrorMessage({ ...errorMessage, mobileNoError: INVALID_OTP_ERROR });
    }
  }
  const confirmSubmissionWorkFlow = (e, workflowAction, isStakeholder) => {
    e.preventDefault();
    setWorkflowAction(workflowAction);
    setIsStakeholder(isStakeholder);
    handleLogModalConfirmOpen();
  }
  const onClickVerifyMobileNo = (e) => {
    e.preventDefault();
    setErrorMessage({ ...errorMessage, OTPError: "" });
    setOtpValue("");
    if (isValidMobileNumber(stakeHolderDetails.mobileNo)) {
      sendOTP(stakeHolderDetails.mobileNo, callBackMobileValidation, (decoded.extension_URN ? "OTPVerification-Stakeholder" : "OTPVerification-Assistant"));
      setErrorMessage({ ...errorMessage, mobileNoError: "" });
    }
    else
      setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
  }
  const confirmSubmission = (e, isRegistrationSubmit) => {
    e.preventDefault();
    if (!validateDetails()) {
      return;
    }
    else {
      handleLogModalYes();
    }
  }
  const onOtpChange = (e) => {
    const limit = 6;
    setOtpValue(e.target.value.slice(0, limit))
    if (e.target.value.length == 6) {
      validateOTP(stakeHolderDetails.mobileNo, e.target.value, callBackOTPValidation, (decoded.extension_URN ? "OTPVerification-Stakeholder" : "OTPVerification-Assistant"));
    }
  }
  const validateDetails = () => {
    if (!checkTermChecked) {
      setErrorMessage({ ...errorMessage, acceptTermError: "Please accept the Privacy Policy and Terms of Use of ABEPL." });
      return false;
    }
    else if (!mobileOTPValidated && verifyMobileNo) {
      setErrorMessage({ ...errorMessage, acceptTermError: "Please enter the OTP sent to your mobile number" });
      return false;
    }
    else {
      setErrorMessage({ ...errorMessage, acceptTermError: "" });
      return true;
    }
  }
  const onSubmitClick = () => {
    handleConfirmLogModalClose();
    setButtonAction("submit");
    setCallUpdateApi(true)
  }
  const handleCheckboxTerms = (e) => {
    if (e.target.checked) {
      e.preventDefault();
      setErrorMessage({ ...errorMessage, OTPError: "" });
      setOtpValue("");
      if (isValidMobileNumber(stakeHolderDetails.mobileNo)) {
        sendOTP(stakeHolderDetails.mobileNo, callBackMobileValidation, (decoded.extension_URN ? "OTPVerification-Stakeholder" : "OTPVerification-Assistant"));
        setErrorMessage({ ...errorMessage, mobileNoError: "", acceptTermError: "" });
        setCheckTermChecked(true);
        setCheckTermDisable(true);
      }
      else {
        setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
        setCheckTermChecked(false);
      }
    }
  }
  const isValidMobileNumber = (mobileNo) => {
    if (mobileNo.length == 10) {
      return true;
    }
    return false;
  }
  useEffect(() => {
    if (props?.callWorkFlowApi) {
      onSubmit()
    }
  }, [props?.callWorkFlowApi]);

  const disableActionButtons = (action) => {
    if (viewOnly) {
      return true
    }
    if (stakeHolderDetails?.categoryName === "Transporter" || stakeHolderDetails?.categoryName === "HIT") {
      if (action === "Request_Clarification" || action === "Reject") {
        if (personalDetailsSectionOk && bankDetailsSectionOk && agreementDetailsSectionOk && vehicleDetailsSectionOk) {
          return true
        }
      }
      if (action === "Approve" || action === "Submit_Clarification" || action === "Submit") {
        if (!personalDetailsSectionOk || !bankDetailsSectionOk || !agreementDetailsSectionOk || !vehicleDetailsSectionOk) {
          return true
        }
      }
    }
    if (stakeHolderDetails?.categoryName === "LLE") {
      if (action === "Request_Clarification" || action === "Reject") {
        if (personalDetailsSectionOk && bankDetailsSectionOk && agreementDetailsSectionOk && qualificationDetailsSectionOk && chippingLocationDetailsSectionOk && locationDetailsSectionOk) {
          return true
        }
      }
      if (action === "Approve" || action === "Submit_Clarification" || action === "Submit") {
        if (!personalDetailsSectionOk || !bankDetailsSectionOk || !agreementDetailsSectionOk || !qualificationDetailsSectionOk || !chippingLocationDetailsSectionOk || !locationDetailsSectionOk) {
          return true
        }
      }
    }
    if (stakeHolderDetails?.categoryName === "Interim Storage Operator") {
      if (action === "Request_Clarification" || action === "Reject") {
        if (personalDetailsSectionOk && bankDetailsSectionOk && agreementDetailsSectionOk && financeDetailsSectionOk && locationDetailsSectionOk) {
          return true
        }
      }
      if (action === "Approve" || action === "Submit_Clarification" || action === "Submit") {
        if (!personalDetailsSectionOk || !bankDetailsSectionOk || !agreementDetailsSectionOk || !financeDetailsSectionOk || !locationDetailsSectionOk) {
          return true
        }
      }
    }
    if (stakeHolderDetails?.growerMasters[0]?.growerType === "Individual") {
      if (action === "Request_Clarification" || action === "Reject") {
        if (personalDetailsSectionOk && bankDetailsSectionOk && Object.values(landDetailsSectionOk).every((item) => item === true)) {
          return true
        }
      }
      if (action === "Approve" || action === "Submit_Clarification" || action === "Submit") {
        if (!personalDetailsSectionOk || !bankDetailsSectionOk || Object.values(landDetailsSectionOk).every((item) => item === false)) {
          return true
        }
      }
    }
    if (stakeHolderDetails?.growerMasters[0]?.growerType === "JFMC") {
      if (action === "Request_Clarification" || action === "Reject") {
        if (personalDetailsSectionOk && bankDetailsSectionOk && agreementDetailsSectionOk && jfmcDetailsSectionOk && Object.values(landDetailsSectionOk).every((item) => item === true)) {
          return true
        }
      }
      if (action === "Approve" || action === "Submit_Clarification" || action === "Submit") {
        if (!personalDetailsSectionOk || !bankDetailsSectionOk || !agreementDetailsSectionOk || !jfmcDetailsSectionOk || Object.values(landDetailsSectionOk).every((item) => item === false)) {
          return true
        }
      }
    }
    if (stakeHolderDetails?.growerMasters[0]?.growerType === "Other Agency" || stakeHolderDetails?.growerMasters[0]?.growerType === "Co-operative" || stakeHolderDetails?.growerMasters[0]?.growerType === "FPO" || stakeHolderDetails?.growerMasters[0]?.growerType === "SHG" || stakeHolderDetails?.growerMasters[0]?.growerType === "FPC") {
      if (action === "Request_Clarification" || action === "Reject") {
        if (personalDetailsSectionOk && bankDetailsSectionOk && agreementDetailsSectionOk && Object.values(landDetailsSectionOk).every((item) => item === true)) {
          return true
        }
      }
      if (action === "Approve" || action === "Submit_Clarification" || action === "Submit") {
        if (!personalDetailsSectionOk || !bankDetailsSectionOk || !agreementDetailsSectionOk || Object.values(landDetailsSectionOk).every((item) => item === false)) {
          return true
        }
      }
    }
    if (stakeHolderDetails?.growerMasters[0]?.growerType === "Forest") {
      if (action === "Request_Clarification" || action === "Reject") {
        if (personalDetailsSectionOk && bankDetailsSectionOk && agreementDetailsSectionOk && Object.values(coupeDetailsSectionOk).every((item) => item === true) && Object.values(beatDetailsSectionOk).every((item) => item === true)) {
          return true
        }
      }
      if (action === "Approve" || action === "Submit_Clarification" || action === "Submit") {
        if (!personalDetailsSectionOk || !bankDetailsSectionOk || !agreementDetailsSectionOk || Object.values(coupeDetailsSectionOk).some((item) => item === false) || Object.values(beatDetailsSectionOk).some((item) => item === false)) {
          return true
        }
      }
    }
  }
  return (
    <>
      <Container maxWidth="xxl" >
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG38</p>}
        <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1} mb={1}>
            <Fab onClick={props.goBack} size="small" aria-label="back" title='Back'>
              <KeyboardArrowLeftRounded />
            </Fab>
            <Typography variant="h5" gutterBottom>
              {t('reg.registrationDetails')}
            </Typography>
          </Stack>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1} mr={2}>
            <Fab onClick={print} hidden={getLocalStorageItem('role') === ROLES?.RegAssistant || getLocalStorageItem('role') === ROLES?.RegSuperVisor || getLocalStorageItem('role') === ROLES?.RegistrationScruitnizer} size="small" aria-label="back" title='Back'>
              <PrintIcon />
            </Fab>
          </Stack>
        </Stack>
        <Card variant="outlined">
          <CardContent>
            <div style={{ height: "55vh", overflowY: "scroll", overflowX: "hidden" }}>
              <ViewPage urn={props.urn} ref={componentRef} isPreview="true" isScrutinyView="true" bambooSpeciesRes={props.bambooSpeciesRes}></ViewPage>
            </div>
          </CardContent>
        </Card>
        {(localStorage.getItem('role') == ROLES.RegistrationScruitnizer || decoded.extension_URN) && !showWorkFlowButtons && !showClarificationButton && enableSaveSubmitButtons &&
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <FormGroup>
                <br />
                <FormControlLabel control={<Checkbox checked={checkTermChecked} onChange={(e) => handleCheckboxTerms(e)} disabled={checkTermDisable} />} label={<><label for="chkTerms"> I agree to the <a href={LINKS.PRIVACY_POLICY}>Privacy Policy</a> and <a href={LINKS.TERMS_OF_USE}>Terms of Use</a> of ABEPL and declare that the shared information to be true to the best of my knowledge.</label></>} ></FormControlLabel>
              </FormGroup>
              <div style={{ color: "#d32f2f", fontSize: "0.75 rem" }}>{errorMessage.acceptTermError}</div>
            </Grid>
            <Grid item xs={3}>
              {verifyMobileNo &&

                <TextField fullWidth
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  onKeyDown={(evt) => typeNumberValid(evt)}
                  onChange={(e) => onOtpChange(e)}
                  label={t('preReg.otp')}
                  value={otpValue} />

              }
              {verifyMobileNo === true &&
                <div>
                  <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</a></div>
              }
            </Grid>
          </Grid>}
        <Box style={{ float: "right" }}>
          {!showWorkFlowButtons && !showClarificationButton && <Button sx={{ minWidth: 100, ml: 1, mt: 3 }} variant="contained" onClick={(props?.stakeholderType === "Grower" || props?.stakeholderType === "Transporter" || props?.stakeholderType === "HIT" || props?.stakeholderType === "LLE" || props?.stakeholderType === "TempStorage") ? (e) => confirmSubmission(e, true) : props.confirm}
            disabled={(props?.stakeholderType === "Grower" || props?.stakeholderType === "Transporter" || props?.stakeholderType === "HIT" || props?.stakeholderType === "LLE" || props?.stakeholderType === "TempStorage") ? !enableSaveSubmitButtons || (localStorage.getItem('role') === ROLES.RegistrationScruitnizer && userType !== "Internal" && disableActionButtons("Submit") || !mobileOTPValidated) : props.disabledbtn}
            endIcon={<SubmitIcon />}
          >Submit</Button>}
          {showWorkFlowButtons &&
            <><Button sx={{ minWidth: 100, ml: 1, mt: 3 }} variant="contained" onClick={(e) => confirmSubmissionWorkFlow(e, "Request_Clarification", false)} disabled={disableActionButtons("Request_Clarification")} startIcon={<ReportIcon />}>Seek Clarification</Button>
              <Button sx={{ minWidth: 100, ml: 1, mt: 3 }} variant="contained" onClick={(e) => confirmSubmissionWorkFlow(e, "Approve", false)} disabled={disableActionButtons("Approve")} startIcon={<ApproveIcon />}>Approve</Button>
              <Button sx={{ minWidth: 100, ml: 1, mt: 3 }} variant="contained" onClick={(e) => confirmSubmissionWorkFlow(e, "Reject", false)} disabled={disableActionButtons("Reject")} startIcon={<CloseIcon />}>{localStorage.getItem('role') === ROLES.RegInCharge ? "Reject" : "Propose Rejection"}</Button>
            </>}
          {showClarificationButton && <Button sx={{ minWidth: 100, ml: 1, mt: 3 }} variant="contained" onClick={(e) => confirmSubmissionWorkFlow(e, "Submit_Clarification", decoded.extension_URN ? true : false)} disabled={disableActionButtons("Submit_Clarification")} endIcon={<SubmitIcon />}>Submit Clarification</Button>
          }
        </Box>
      </Container>
      <ConfirmationPopover onOpen={logModalOpenConfirm} action="Submit" onConfirm={onSubmit} onClose={handleLogModalConfirmClose} />
      <ConfirmationPopover onOpen={logModalYes} action="Submit" onConfirm={onSubmitClick} onClose={handleConfirmLogModalClose} />
    </>
  )
}
export default Preview;
